import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import { Draw, Modify, Translate } from 'ol/interaction.js';
import { MultiPoint, Point } from 'ol/geom.js';
import VectorSource from 'ol/source/Vector.js';
import { Vector as VectorLayer } from 'ol/layer.js';
import { getCenter, getHeight, getWidth } from 'ol/extent.js';
import { never, platformModifierKeyOnly, primaryAction } from 'ol/events/condition.js';
import { createBox } from 'ol/interaction/Draw';
import { fromExtent } from 'ol/geom/Polygon';
import OlSourceImageStatic from 'ol/source/ImageStatic';
import OlLayerImage from 'ol/layer/Image';
import { Projection, addCoordinateTransforms, addProjection, get as getProjection } from 'ol/proj';
import { transform } from 'ol/proj';
import { transformExtent } from 'ol/proj';
import { rotate } from 'ol/coordinate';
import OlPolygon from 'ol/geom/Polygon.js';
import OlFeature from 'ol/Feature.js';
import App from '@gral/app';
import actions from '@flux/actions/actView';
import { EAclAction } from '@ts/ui-models';
import { getIndexLayers } from '@components/Maps/utils/map.utils';
import { CMapLayer } from '@models/maps/Layer';

const t4326 = v => v && transform(v, 'EPSG:3857', 'EPSG:4326');
const t3857 = v => v && transform(v, 'EPSG:4326', 'EPSG:3857');
const te4326 = v => transformExtent(v, 'EPSG:3857', 'EPSG:4326');
const te3857 = v => transformExtent(v, 'EPSG:4326', 'EPSG:3857');

const INTERACTION_LAYER = 'interactionLayerIndoor';

// x = longitud = [0]  y = latitud = [1]

/* const point1 = t3857([1.5993966439492038, 43.11786340555253]);
const point2 = t3857([1.599194215143489, 43.11901231525161]);
const point3 = t3857([1.6022981235510643, 43.11931906931119]);
const point4 = t3857([1.602500797969752, 43.11816956770238]);

const coordinatesMavis = [point1, point2, point3, point4, point1]; */

/* export interface Rectangle {
    extent: [minx, miny, maxx, maxy],
    angle: number,
    center: [x,y],
} */

export default class MapIndoorLayer {
  _map: any = undefined;
  _layer?: CMapLayer = undefined;
  _layers?: CMapLayer[] = undefined;
  _vector: any = undefined;
  _isEditMapIndoor = false;
  _isFitMapIndoor = false;
  _isSatelliteMap = false;
  _transparency = 0.5;
  _isExistMapIndoor: any = undefined;
  _urlImage = '';

  _listInteractions: any[] = [];
  _listTransformations: any[] = [];

  constructor(map, url, layer, layers, transparency) {
    this._map = map;
    this._urlImage = url;
    this._layer = layer;
    this._layers = layers;

    this._transparency = transparency;
    this.showLayerIfExist(layer);
  }

  //#region Setters & Getters
  get isSatelliteMap() {
    return this._isSatelliteMap;
  }
  get getExtent() {
    return this._isExistMapIndoor && this._isExistMapIndoor.extent;
  }
  set isEditMapIndoor(isEditMapIndoor) {
    this._isEditMapIndoor = isEditMapIndoor;
    this.changeIsEditMap();
  }
  set urlImage(urlImage) {
    this._urlImage = urlImage;
  }
  get transparency() {
    return this._transparency;
  }
  set transparency(transparency) {
    this._transparency = transparency;
    this.rePaintImageLayer();
  }
  set isSatelliteMap(isSatelliteMap) {
    this._isSatelliteMap = isSatelliteMap;
    /* setTimeout(() => {
      this.removeAllInteractionAndLayer();
      this.changeIsEditMap();
    }, 1000); */
  }
  showLayerIfExist(layer) {
    if (
      layer.properties.vertexBottomLeft &&
      layer.properties.vertexBottomRight &&
      layer.properties.vertexTopLeft &&
      layer.properties.vertexTopRight
    ) {
      this._layer = layer;
      const coordinates = [
        t3857(layer.properties.vertexBottomLeft),
        t3857(layer.properties.vertexTopLeft),
        t3857(layer.properties.vertexTopRight),
        t3857(layer.properties.vertexBottomRight),
        t3857(layer.properties.vertexBottomLeft),
      ];
      this._isExistMapIndoor = this.extentCalculationRectangleWithoutRotation(coordinates);

      this.addImageLayer(this._isExistMapIndoor);
      this._listTransformations.push({
        type: 'create',
        geometry: this._isExistMapIndoor.polygon,
      });
    }
  }
  //#endregion

  //#region HandleChange
  changeIsEditMap = () => {
    if (this._isEditMapIndoor) {
      //AddInteractions
      if (this._isExistMapIndoor) {
        this.initialiseVectorSource();
        this.initialiseTranslate();
        this.initialiseModify();
        this.addImageLayer(this._isExistMapIndoor);
        this.drawModifyRectangle(this._isExistMapIndoor);
        !this._isFitMapIndoor && this.setViewFromRectangle(this._isExistMapIndoor);
        this._isFitMapIndoor = true;
      } else {
        this.initialiseVectorSource();
        this.initialiseTranslate();
        this.initialiseModify();
        this.initialiseDraw();
      }
    } else {
      this.removeAllInteractionAndLayer();
      this.rePaintImageLayer();

      if (this._listTransformations.length <= 1) return;
      this.postViewCoordenates();
      this._isFitMapIndoor = false;
    }
  };
  rePaintImageLayer() {
    this._isExistMapIndoor && this.addImageLayer(this._isExistMapIndoor);
  }
  //#endregion

  addImageLayer = rectangle => {
    this._isExistMapIndoor = rectangle;

    const imageSource = new OlSourceImageStatic({
      url: this._urlImage,
      projection: this.rotateProjection(
        'EPSG:3857',
        this._isExistMapIndoor ? this._isExistMapIndoor.angle : this.sumAngle(this._listTransformations),
        this._isExistMapIndoor.extent
      ),
      imageExtent: this._isExistMapIndoor.extent,
    });

    const imageLayer = new OlLayerImage({
      source: imageSource,
      visible: true,
      opacity: this._transparency,
      zIndex: getIndexLayers('imageLayer'),
    });

    imageLayer.set('id', 'imageLayer' + this._layer?.getID());
    imageLayer.set('name', this._layer?.getID());
    //imageLayer.set('taLayer', this._layer);

    const imageRemoveLayer = this._map
      .getLayers()
      .getArray()
      .find(layer => layer.get('id') === 'imageLayer' + this._layer?.getID());
    if (imageRemoveLayer) this._map.removeLayer(imageRemoveLayer);
    this._map.addLayer(imageLayer);
  };

  removeAllInteractionAndLayer = () => {
    const interactionRemoveLayer = this._map
      .getLayers()
      .getArray()
      .find(layer => layer.get('name') === INTERACTION_LAYER);
    if (interactionRemoveLayer) this._map.removeLayer(interactionRemoveLayer);
    this._listInteractions.forEach(int => {
      this._map.removeInteraction(int.action);
    });
    this._listInteractions = [];
  };

  //#region ACTIONs
  postViewCoordenates = () => {
    const { viewId } = this._layer ?? {};
    const extractBdLayer = this._layers?.map(l => {
      if (l.getID() === this._layer?.getID()) {
        const vertex = this.getFourCoordenatesFromPolygon(this._isExistMapIndoor.polygon);
        l.properties = {
          ...l.properties,
          vertexBottomLeft: vertex.vertexBottomLeft,
          vertexTopLeft: vertex.vertexTopLeft,
          vertexTopRight: vertex.vertexTopRight,
          vertexBottomRight: vertex.vertexBottomRight,
        };
      }
      return l;
    });
    const checkPermission = App.cxStore.checkPermission('taView', EAclAction.EDIT);

    if (checkPermission) {
      const rsrc = {
        attrs: this.processAttrsBeforeSend({ xViewLayers: extractBdLayer }),
        dataPath: 'map_view',
        url: '/api/view/' + viewId,
      };
      actions['update'](rsrc);
    }
  };
  processAttrsBeforeSend = attrs0 => {
    // For those fields where we need to do something before sending
    // like trimming spaces for names or customIds
    const attrs = { ...attrs0 };
    if (attrs.name) {
      attrs.name = attrs.name.trim();
    }
    if (attrs.logicalId) {
      attrs.logicalId = attrs.logicalId.trim();
    }
    if (attrs.customId) {
      attrs.customId = attrs.customId.trim();
    }
    return attrs;
  };
  //#endregion

  //#region VectorSource & styles
  source = new VectorSource();

  styleVector = new Style({
    geometry: feature => {
      const modifyGeometry = feature.get('modifyGeometry');
      return modifyGeometry ? modifyGeometry.geometry : feature.getGeometry();
    },
    fill: new Fill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
    stroke: new Stroke({
      color: '#ffcc33',
      width: 2,
    }),
    image: new CircleStyle({
      radius: 7,
      fill: new Fill({
        color: '#ffcc33',
      }),
    }),
  });

  defaultStyle = new Modify({ source: this.source }).getOverlay().getStyleFunction();

  initialiseVectorSource = () => {
    this.source = new VectorSource();

    this._vector = new VectorLayer({
      //@ts-ignore
      id: INTERACTION_LAYER,
      name: INTERACTION_LAYER,
      source: this.source,
      style: feature => {
        const styles = [this.styleVector];
        const modifyGeometry = feature.get('modifyGeometry');
        const geometry = modifyGeometry ? modifyGeometry.geometry : feature.getGeometry();
        const result = this.calculateCenter(geometry);
        const center = result.center;
        if (center) {
          styles.push(
            new Style({
              geometry: new Point(center),
              image: new CircleStyle({
                radius: 4,
                fill: new Fill({
                  color: '#ff3333',
                }),
              }),
            })
          );
          const coordinates = result.coordinates;
          if (coordinates) {
            const minRadius = result.minRadius;
            const sqDistances = result.sqDistances;
            const rsq = minRadius * minRadius;
            const points = coordinates.filter((coordinate, index) => {
              return sqDistances[index] > rsq;
            });
            const multiPoint = new MultiPoint(points);
            styles.push(
              new Style({
                geometry: multiPoint,
                image: new CircleStyle({
                  radius: 6,
                  fill: new Fill({
                    color: '#07aef5',
                  }),
                }),
              })
            );
          }
        }
        return styles;
      },
    });

    this._map.addLayer(this._vector);
  };
  //#endregion

  //#region Modify transformations
  initialiseModify = () => {
    this.source.on('addfeature', event => {
      const feature = event.feature;
      feature?.set('noTooltip', true); // Propiedad se establece al momento de creación
    });
    const modify = new Modify({
      source: this.source,
      condition: event => {
        return primaryAction(event) && !platformModifierKeyOnly(event);
      },
      deleteCondition: never,
      insertVertexCondition: never,
      style: feature => {
        feature.get('features').forEach(modifyFeature => {
          const modifyGeometry = modifyFeature.get('modifyGeometry');

          if (modifyGeometry) {
            //@ts-ignore
            const point = feature.getGeometry()?.getCoordinates();
            let modifyPoint = modifyGeometry.point;
            if (!modifyPoint) {
              // save the initial geometry and vertex position
              modifyPoint = point;
              modifyGeometry.point = modifyPoint;
              modifyGeometry.geometry0 = modifyGeometry.geometry;
              // get anchor and minimum radius of vertex to be used
              const result = this.calculateCenter(modifyGeometry.geometry0);
              modifyGeometry.center = result.center;
              modifyGeometry.minRadius = result.minRadius;
            }
            //@ts-ignore
            const pointMoved = feature.getGeometry()?.getCoordinates();

            const transformation = geometry => {
              let coordinates = geometry.getCoordinates()[0];
              //@ts-ignore
              const { index, type } = this.identifyIndexMoving(coordinates, modifyPoint);
              const oppositeIndex = this.getOppositeVertexIndex(index, coordinates.length - 1);

              if (type === 'rotate') {
                const center = modifyGeometry.center;
                const minRadius = modifyGeometry.minRadius;
                let dx, dy;
                dx = modifyPoint[0] - center[0];
                dy = modifyPoint[1] - center[1];
                const initialRadius = Math.sqrt(dx * dx + dy * dy);
                if (initialRadius > minRadius) {
                  const initialAngle = Math.atan2(dy, dx);
                  dx = point[0] - center[0];
                  dy = point[1] - center[1];
                  const currentRadius = Math.sqrt(dx * dx + dy * dy);
                  if (currentRadius > 0) {
                    const currentAngle = Math.atan2(dy, dx);
                    geometry.scale(
                      currentRadius / initialRadius,
                      undefined,
                      coordinates[this.getOppositeVertexIndex(index, coordinates.length - 1)]
                    );
                    geometry.rotate(currentAngle - initialAngle, coordinates[oppositeIndex]);

                    modifyGeometry.transformation = {
                      geometry,
                      type,
                      angle: currentAngle - initialAngle,
                      degrees: ((currentAngle - initialAngle) * 180) / Math.PI,
                      scaleFactor: currentRadius / initialRadius,
                      centre: coordinates[oppositeIndex],
                    };
                  }
                }
              }

              if (type === 'scale') {
                const { extent, angle, center } = this.getRectangleFromGeometry(geometry);
                const [minX, minY, maxX, maxY] = extent;

                const coordenadas = [
                  [minX, minY],
                  [minX, maxY],
                  [maxX, maxY],
                  [maxX, minY],
                  [minX, minY],
                ];
                const rect10 = this.splitEdgeFromCoordinates([coordenadas]);

                coordinates = this.scaleEdgeCoordinates(
                  rect10[0],
                  index,
                  geometry.getCoordinates()[0][index],
                  pointMoved,
                  (angle * 180) / Math.PI
                );
                geometry.setCoordinates([coordinates]);
                geometry.rotate(angle, center);

                modifyGeometry.transformation = {
                  geometry,
                  type,
                };
              }
            };

            const geometryInverse = this.transformationsModify(modifyGeometry.geometry0, transformation);
            modifyGeometry.geometry = geometryInverse;
          }
        });
        //@ts-ignore
        return this.defaultStyle(feature);
      },
    });

    modify.on('modifystart', event => {
      event.features.forEach(feature => {
        feature.set('modifyGeometry', { geometry: feature.getGeometry()?.clone() }, true);
      });
    });

    modify.on('modifyend', event => {
      event.features.forEach(feature => {
        const modifyGeometry = feature.get('modifyGeometry');

        if (modifyGeometry) {
          this._listTransformations.push(modifyGeometry.transformation);

          feature.setGeometry(modifyGeometry.geometry);
          feature.unset('modifyGeometry', true);

          const rectangle = this.getRectangleFromGeometry(modifyGeometry.geometry.clone());
          this.addImageLayer(rectangle);
        }
      });
    });

    this._listInteractions.push({ type: 'modify', action: modify });
    this._map.addInteraction(modify);
  };
  //#endregion

  //#region Translate Movement
  initialiseTranslate = () => {
    const translate = new Translate({
      condition: event => {
        return primaryAction(event);
      },
      layers: [this._vector],
    });

    translate.on('translateend', event => {
      event.features.forEach(feature => {
        const translateGeometry = feature.getGeometry();

        this.addImageLayer(this.getRectangleFromGeometry(translateGeometry));
      });
    });
    this._listInteractions.push({ type: 'translate', action: translate });
    this._map.addInteraction(translate);
  };
  //#endregion

  //#region Draw object (Rectangle)
  initialiseDraw = () => {
    const draw = new Draw({
      source: this.source,
      type: 'Circle',
      geometryFunction: createBox(),
      maxPoints: 2,
    });

    draw.on('drawend', event => {
      const geometry = event.feature.getGeometry();

      const extent = geometry?.getExtent();
      if (extent) {
        const polygon = fromExtent(extent);
        let newCoords = this.splitEdgeFromCoordinates(polygon.getCoordinates());
        polygon.setCoordinates(newCoords);
        event.feature.setGeometry(polygon);

        this._listTransformations.push({ type: 'create', geometry: polygon });
        this.addImageLayer(this.getRectangleFromGeometry(polygon));

        this._map.removeInteraction(draw);
      }
    });

    this._listInteractions.push({ type: 'draw', action: draw });
    this._map.addInteraction(draw);
  };
  drawModifyRectangle = mapIndoor => {
    const rectangle = fromExtent(mapIndoor.extent);
    let newCoords = this.splitEdgeFromCoordinates(rectangle.getCoordinates());
    rectangle.setCoordinates(newCoords);
    rectangle.rotate(mapIndoor.angle, mapIndoor.center);
    const newFeature = new OlFeature({
      geometry: rectangle,
    });
    this.source.addFeature(newFeature);
    this._listTransformations.push({
      type: 'rotate',
      geometry: rectangle,
      angle: mapIndoor.angle,
      degrees: (mapIndoor.angle * 180) / Math.PI,
      scaleFactor: 0,
      centre: mapIndoor.center,
    });
  };

  //#endregion

  //#region Geometry Functions
  //We need the sum of the angles because the rotation is calculated from the last movement.
  sumAngle = la => {
    return la.reduce((accumulator, currentValue) => {
      return accumulator + (currentValue.angle ? currentValue.angle : 0);
    }, 0);
  };
  //Identify the nearest index and say whether it is to scale or rotate
  identifyIndexMoving = (coordinates, point) => {
    let closestVertexIndex = -1;
    let minDistance = Infinity;

    const isIndexForRotate = i => i % 2 === 0;

    for (let i = 0; i < coordinates.length; i++) {
      const vertex = coordinates[i];
      const distance = Math.sqrt((vertex[0] - point[0]) ** 2 + (vertex[1] - point[1]) ** 2);

      if (distance < minDistance) {
        minDistance = distance;
        closestVertexIndex = i;
      }
    }

    if (closestVertexIndex !== -1) {
      //const closestVertex = coordinates[closestVertexIndex];
      return {
        index: closestVertexIndex,
        type: isIndexForRotate(closestVertexIndex) ? 'rotate' : 'scale',
      };
    } else {
      return -1;
    }
  };

  getOppositeVertexIndex = (index, totalVertices) => {
    const oppositeIndex = (index + Math.floor(totalVertices / 2)) % totalVertices;
    return oppositeIndex;
  };

  calculateCenter = geometry => {
    let center, coordinates, minRadius;
    const type = geometry.getType();
    if (type === 'Polygon') {
      let x = 0;
      let y = 0;
      let i = 0;
      coordinates = geometry.getCoordinates()[0].slice(1);
      coordinates.forEach(coordinate => {
        coordinate = coordinate;
        x += coordinate[0];
        y += coordinate[1];
        i++;
      });
      center = [x / i, y / i];
    } else if (type === 'LineString') {
      center = geometry.getCoordinateAt(0.5);
      coordinates = geometry.getCoordinates();
    } else {
      center = getCenter(geometry.getExtent());
    }
    let sqDistances;
    if (coordinates) {
      sqDistances = coordinates.map(coordinate => {
        coordinate = coordinate;
        const dx = coordinate[0] - center[0];
        const dy = coordinate[1] - center[1];
        return dx * dx + dy * dy;
      });
      minRadius = Math.sqrt(Math.max.apply(Math, sqDistances)) / 3;
    } else {
      minRadius = Math.max(getWidth(geometry.getExtent()), getHeight(geometry.getExtent())) / 3;
    }
    return {
      center: center,
      coordinates: coordinates,
      minRadius: minRadius,
      sqDistances: sqDistances,
    };
  };

  //Divide each edge into two equal segments to determine the midpoint.
  splitEdgeFromCoordinates = coordinates => {
    let newCoord: any[] = [];
    coordinates.forEach(ring => {
      const splitCoord: any[] = [];
      ring.forEach((vertex, i, arr) => {
        const nextVertex = arr[(i + 1) % arr.length];
        const midX = (vertex[0] + nextVertex[0]) / 2;
        const midY = (vertex[1] + nextVertex[1]) / 2;
        splitCoord.push(vertex);
        if (i !== arr.length - 1) {
          splitCoord.push([midX, midY]);
        }
      });
      newCoord = splitCoord;
    });

    return [newCoord];
  };

  //From one vertex move the others to enlarge one side
  scaleEdgeCoordinates = (coordinates, vertexIndex, vertexMove, newPoint, degree) => {
    const countVertex = coordinates.length - 1;
    const moveX = [1, 5];
    const moveY = [3, 7];

    // Check if the index of the vertex is within the valid range
    if (vertexIndex >= countVertex || vertexIndex < 0) {
      throw new Error('Invalid vertex index');
    }

    // Obtain the coordinates of the vertex to be moved
    const vertex = vertexMove;

    // Calculate the difference in X and Y coordinates
    const dx = ((moveY.includes(vertexIndex) ? vertex[0] : newPoint[0]) - vertex[0]) * (degree > 90 && degree < 270 ? -1 : 1);
    const dy = ((moveX.includes(vertexIndex) ? vertex[1] : newPoint[1]) - vertex[1]) * (degree > 90 && degree < 270 ? -1 : 1);

    coordinates[vertexIndex][0] += dx;
    coordinates[vertexIndex][1] += dy;

    const prevVertexIndex = (vertexIndex - 1 + countVertex) % countVertex;
    const nextVertexIndex = (vertexIndex + 1) % countVertex;

    const prevVertex = coordinates[prevVertexIndex];
    const nextVertex = coordinates[nextVertexIndex];

    prevVertex[0] += dx;
    prevVertex[1] += dy;
    nextVertex[0] += dx;
    nextVertex[1] += dy;

    //#region Move adjacentsVertex
    const prevprevVertexIndex = (vertexIndex - 2 + countVertex) % countVertex;
    const prevprevpVertexIndex = (vertexIndex - 3 + countVertex) % countVertex;
    const nextnextVertexIndex = (vertexIndex + 2) % countVertex;
    const nextnextnVertexIndex = (vertexIndex + 3) % countVertex;

    const prevmidX = (coordinates[prevprevpVertexIndex][0] + coordinates[prevVertexIndex][0]) / 2;
    const prevmidY = (coordinates[prevprevpVertexIndex][1] + coordinates[prevVertexIndex][1]) / 2;
    coordinates[prevprevVertexIndex][0] = prevmidX;
    coordinates[prevprevVertexIndex][1] = prevmidY;

    const nextmidX = (coordinates[nextnextnVertexIndex][0] + coordinates[nextVertexIndex][0]) / 2;
    const nextmidY = (coordinates[nextnextnVertexIndex][1] + coordinates[nextVertexIndex][1]) / 2;
    coordinates[nextnextVertexIndex][0] = nextmidX;
    coordinates[nextnextVertexIndex][1] = nextmidY;

    //#endregion

    //vertices 0 and 8 must always move the same way
    if (vertexIndex === 1 || vertexIndex === 7) {
      coordinates[8] = coordinates[0];
    }

    return coordinates;
  };

  //Is to apply some changes to the geometry of the modify that is in another projection.
  transformationsModify = (geometry, transformation) => {
    //const cloneGeometry = geometry.clone().transform('EPSG:3857', 'EPSG:4326');
    const cloneGeometry = geometry.clone();

    transformation(cloneGeometry);

    //return cloneGeometry.clone().transform('EPSG:4326', 'EPSG:3857');
    return cloneGeometry.clone();
  };

  //From a geometry we obtain the rectangle to know the rotation.
  getRectangleFromGeometry = geometry => {
    const coordinates = geometry.getCoordinates()[0];
    const coorPolygonRectante = [coordinates[0], coordinates[2], coordinates[4], coordinates[6], coordinates[0]];

    const newExtent = this.extentCalculationRectangleWithoutRotation(coorPolygonRectante);

    return newExtent;
  };

  //#endregion

  //#region Map functions
  setViewFromRectangle = rectangle => {
    this._map.getView().fit(rectangle.extent, {
      duration: 800,
      size: this._map.getSize(),
    });
  };
  //#endregion

  //Get four points coordenates 4326 from polygon
  getFourCoordenatesFromPolygon(polygon) {
    const coordenates = polygon.getCoordinates()[0];
    return {
      vertexBottomLeft: t4326(coordenates[0]),
      vertexTopLeft: t4326(coordenates[1]),
      vertexTopRight: t4326(coordenates[2]),
      vertexBottomRight: t4326(coordenates[3]),
    };
  }

  //Needs coordinates of a rectangular polygon (4+1)
  extentCalculationRectangleWithoutRotation(coordinates) {
    const polygon = new OlPolygon([coordinates]);
    const clonePolygon = polygon.clone();

    const centerX = (coordinates[0][0] + coordinates[2][0]) / 2;
    const centerY = (coordinates[0][1] + coordinates[2][1]) / 2;

    // Calculate center
    const centerXcalculateAngle = (coordinates[0][0] + coordinates[3][0]) / 2;
    const centerYcalculateAngle = (coordinates[0][1] + coordinates[3][1]) / 2;
    // Calculate anglee
    const deltaX = coordinates[0][0] - centerXcalculateAngle;
    const deltaY = coordinates[0][1] - centerYcalculateAngle;
    const rotationAngle = Math.atan2(deltaY, deltaX);

    coordinates[0][1] !== coordinates[3][1] && polygon.rotate(Math.PI - rotationAngle, [centerX, centerY]);

    return {
      extent: polygon.getExtent(),
      angle: coordinates[0][1] === coordinates[3][1] ? 0 : rotationAngle + Math.PI,
      center: getCenter(polygon.getExtent()),
      polygon: clonePolygon,
    };
  }

  //A rotated projection is created
  rotateProjection(projection, angle, extent, center?) {
    angle = angle * -1;
    const rotateCoordinate = (coordinate, angle, anchor) => {
      var coord = rotate([coordinate[0] - anchor[0], coordinate[1] - anchor[1]], angle);
      return [coord[0] + anchor[0], coord[1] + anchor[1]];
    };

    const rotateTransform = coordinate => {
      return rotateCoordinate(coordinate, angle, center || getCenter(extent));
    };

    const normalTransform = coordinate => {
      return rotateCoordinate(coordinate, -angle, center || getCenter(extent));
    };

    const normalProjection = getProjection(projection);

    if (normalProjection) {
      const rotatedProjection = new Projection({
        code: normalProjection.getCode() + ':' + angle.toString() + ':' + extent.toString(),
        units: normalProjection.getUnits(),
        extent: extent,
      });
      addProjection(rotatedProjection);

      addCoordinateTransforms(
        'EPSG:4326',
        rotatedProjection,
        coordinate => {
          return rotateTransform(transform(coordinate, 'EPSG:4326', projection));
        },
        coordinate => {
          return transform(normalTransform(coordinate), projection, 'EPSG:4326');
        }
      );

      addCoordinateTransforms(
        'EPSG:3857',
        rotatedProjection,
        coordinate => {
          return rotateTransform(transform(coordinate, 'EPSG:3857', projection));
        },
        coordinate => {
          return transform(normalTransform(coordinate), projection, 'EPSG:3857');
        }
      );
      return rotatedProjection;
    }
  }
}
